import React from 'react';
import { LoginNode, PageNode, ActionNode, AssertionNode, SetupNode, SeedNode, CallFlowNode, WaitNode, ConditionNode, ApiSequenceNode, SandboxActionNode, McpNode, EndNode, NotificationNode, AudioNode, AudioAssertionNode, VisualCheckpointNode } from '@chatsdet/ui';
export type NodeTypes = Record<string, React.ComponentType<any>>;

export type ActionPageContext = {
  canonicalPageId?: string | null;
  pageTitle?: string | null;
  pageUrl?: string | null;
};

export type CreateNodeOptions = {
  sourceNodeId?: string | null;
  autoSelect?: boolean;
  /** Edge type for conditional branches (condition_true, condition_false, or default) */
  edgeType?: 'condition_true' | 'condition_false' | 'default';
};

export type CreateNodeFn = (
  nodeConfig: { type: string; data: Record<string, any> },
  options?: CreateNodeOptions
) => Promise<string | null>;

export type SidebarTab = 'run' | 'config' | 'ai' | 'comments';

export type FlowView = 'browser' | 'api' | 'lineage' | 'spec';

export const nodeTypes: NodeTypes = {
  login: LoginNode,
  navigate: PageNode,
  action: ActionNode,
  assertion: AssertionNode,
  setup: SetupNode,
  wait: WaitNode,
  condition: ConditionNode,
  seed: SeedNode,
  call_flow: CallFlowNode,
  api_sequence: ApiSequenceNode,
  sandbox_action: SandboxActionNode,
  mcp: McpNode,
  notification: NotificationNode,
  audio: AudioNode,
  'audio-assertion': AudioAssertionNode,
  visual_checkpoint: VisualCheckpointNode,
  end: EndNode,
};
